module.exports = __webpack_public_path__ + "media/landing/slider-2-663429af.jpeg";